module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAANCAYAAAE1YMXLAAAAAXNSR0IArs4c6QAAAMtJREFUOBGtkz0LwjAQhlPxX/g7BDfBxcnJSXEQJ538z+LmruJH0+egR0MSEmN78Pa+32suxJhWrLUXtROask80TeIdJH4kdfroOIg7cmJqWjX+01CfwVO7K5wrzkQDGX3L5I3xJyQbKD6BRbLITVIssnJjSZviL9jIQXvuzpvTMm+9cOjKZCT/zxSVbSOc1UUg28lY5A6WXWZAC+IjqMELrJVatj3DmWqgpxbiOajBfsynaoEaVGJPrnwAp4+upZzJ6YBUL/SBHVxoA7t+lfigeA1CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow-Right.png
// module id = I2s1
// module chunks = 1